import React from 'react';
import { Auth, I18n } from 'aws-amplify';
import {
  SignUp,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  InputRow,
  ButtonRow
} from 'aws-amplify-react';

import EnterPassword from './enterPassword.js';
import LogoArea from './logoarea.js';
import Stepper from './stepper.js';
import LapDialog from '../util/laplaceDialog.js';
import getLatestTermVer from '../util/getLatestTermVer.js';

const defaultState = {
  isDisabled : true,
  openConfirm: false,
  paramPassword:"",
  idError: "",
  passState: {
    isNumOk: false,
    isLowerOk: false,
    isUpperOk: false,
    isOverOk: false,
  },
  otherError: ''
};
export default class FirstSignUp extends SignUp {
  constructor(props) {
    super(props);
    this.state = defaultState;
    this.authInfo = {};
    this.user = {};
    this.inputs = {
      username: ''
    };
  }
  initState = () => {
    this.setState (defaultState);
    this.authInfo = {};
    this.user = {};
    this.inputs = {
      username: ''
    };
  }
  toCloseConfirm = () => {
    this.setState({
      openConfirm: false
    });
  }
  getErrorMessage = (err) => {
    const {code, message} = err;
    if (!code && !message)
      return err;
    if (message)
      return message;
    if (code)
      return code;
    return '';
  }
  updateErrorState = (mes) => {
    let idError, otherError = '';
    if (mes === '') {
      this.setState({
        idError,otherError
      });
      return;
    }
    if(
      mes === 'Username cannot be empty' ||
      mes === 'User does not exist.'
    ) {
      this.setState({
        idError: I18n.get(mes)
      });
      return
    }
    if(
      mes === 'Incorrect username or password.' ||
      mes === 'null failed with error Generate callenges lambda cannot be called..'
    ) {
      if (mes === 'null failed with error Generate callenges lambda cannot be called..') {
        mes = 'Enter your password'
      }
    }
    this.setState({
      otherError: I18n.get(mes)
    });
    return
  }
  signUp() {
    const { username } = this.inputs;
    const param = {
      username: username,
      password: this.state.paramPassword,
      attributes:{
        email:username,
        "custom:is_agree":"0",
        "custom:agreed_term": getLatestTermVer(),
        "custom:account_state":"temporary",
        "custom:user_language":window.LAPLACEID_LOCALE,
      },
    }
    this.authInfo = {
      username,
      pw: this.state.paramPassword,
    };
    Auth.signUp(param).then(() => {
      this.changeState('confirmSignUp', this.authInfo);
      this.initState();
    }).catch((signupErr) => {
      console.log('signupErr');
      console.log(signupErr);
      if (signupErr.code === "UsernameExistsException") {
        this.setState({
          idError: I18n.get('An account with the given email already exists.')
        });
      } else {
        const errStr = this.getErrorMessage(signupErr);
        this.setState({
          otherError: I18n.get(errStr)
        });
      }
    });
  }
  onExitOpenConfirm = () => {
    this.changeState('confirmSignUp', this.authInfo);
    this.initState();
  }
  validateUsername = () => {
    let buttonState;
    let errorStr = "";
    if (this.inputs.username.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      buttonState = false;
    } else {
      if (this.inputs.username === '') {
        errorStr = '';
      } else {
        errorStr = I18n.get('Mail address style is not valid.');
      }
      buttonState = true;
    }
    if (this.state.paramPassword === ''){
      buttonState = true;
    }

    this.setState({
      idError : errorStr,
      isDisabled : buttonState
    });
  }
  toggleDisabled = (param) => {
    this.setState({
      isDisabled : param,
    });
  }
  setPassword = (param) => {
    this.setState({
      paramPassword:param,
    });
  }
  setPassState = (param) => {
    this.setState({
      passState:param,
    });
  }
  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type? checked : value;
    this.inputs['checkedValue'] = check_type? value: null;
    if (name === "username") {
      this.validateUsername();
    }
  }
  back = () => {
    this.initState();
    this.changeState('signIn');
  }
  showComponent(theme) {
    // emailを入力してもらっていますが、usernameとして読み替えています
    return (
      <div className="loginContainer firstSignup">
        <LogoArea theme={theme} />
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>{I18n.get('Sign Up Account')}</SectionHeader>
          <Stepper nowStatus="25%" />
          <SectionBody theme={theme}>
            <label className="loginLabel">{I18n.get('Mail')}</label>
            <InputRow
              placeholder={I18n.get('Mail')}
              theme={theme}
              key="username"
              name="username"
              onChange={this.handleInputChange}
            />
            <p className='errorText'>{this.state.idError}</p>
            <EnterPassword
              theme={theme}
              toggleDisabled={this.toggleDisabled}
              setPassword={this.setPassword}
              setPassState={this.setPassState}
              passState={this.state.passState}
              userName={this.inputs.username}
            />
            <div className="loginPassConditions">
              <p className="colNatural01">{I18n.get('Password strength is required belows')}</p>
              <ul>
                <li className={this.state.passState.isNumOk ? 'validCheckImg' : 'notValidCheckImg'}>{I18n.get('Require numbers')}</li>
                <li className={this.state.passState.isUpperOk ? 'validCheckImg' : 'notValidCheckImg'}>{I18n.get('Require uppercase letters')}</li>
                <li className={this.state.passState.isLowerOk ? 'validCheckImg' : 'notValidCheckImg'}>{I18n.get('Require lowercase letters')}</li>
                <li className={this.state.passState.isOverOk ? 'validCheckImg' : 'notValidCheckImg'}>{I18n.get('8 letters more over')}</li>
              </ul>
            </div>
            <p className='errorText'>{this.state.otherError}</p>
            <ButtonRow style={theme.loginLargeButton} onClick={this.signUp} theme={theme} disabled={this.state.isDisabled} >
              {I18n.get('Next')}
            </ButtonRow>
          </SectionBody>
          <SectionFooter theme={theme}>
          </SectionFooter>
        </FormSection>
        <LapDialog contentText={I18n.get('Enter verification code already sent.')} open={this.state.openConfirm} toClose={this.toCloseConfirm} onExit={this.onExitOpenConfirm} />
      </div>
    )
  }
}
